import { useMemo } from 'react';
import { ONBOARDING_SECTIONS, type OnboardingSection, type SectionStatus } from '../types/onboarding';
import { useSectionStatus } from './useSectionStatus';

/**
 * Pure function: checks if all required (non-coming-soon) sections are complete.
 * Exported for unit testing.
 */
export function isAllRequiredComplete(
  sections: OnboardingSection[],
  getStatus: (id: string) => SectionStatus
): boolean {
  return sections
    .filter(s => s.isRequired && !s.isComingSoon)
    .every(s => getStatus(s.id) === 'complete');
}

export function useOnboardingComplete() {
  const { getDataDrivenStatus, isLoading } = useSectionStatus();

  const isOnboardingComplete = useMemo(() => {
    if (isLoading) return false;
    return isAllRequiredComplete(ONBOARDING_SECTIONS, getDataDrivenStatus);
  }, [getDataDrivenStatus, isLoading]);

  return { isOnboardingComplete, isLoading };
}
